/**
 * Scrolls the navigator by the least that shows a row whole, and nothing else:
 * `scrollIntoView` would also move every ancestor that clips the row.
 */
export function keepRowInView(scroller: HTMLElement, row: HTMLElement): void {
    const view = scroller.getBoundingClientRect();
    const box = row.getBoundingClientRect();
    if (box.top < view.top) scroller.scrollTop -= view.top - box.top;
    else if (box.bottom > view.bottom) scroller.scrollTop += Math.min(box.bottom - view.bottom, box.top - view.top);
}
